export const createExponentialRampToValueAutomationEvent = (value, endTime) => {
    return { endTime, type: 'exponentialRampToValue', value };
};
//# sourceMappingURL=create-exponential-ramp-to-value-automation-event.js.map